import { render, staticRenderFns } from "./EditBooking.vue?vue&type=template&id=5c63c7d6&scoped=true"
import script from "./EditBooking.vue?vue&type=script&lang=js"
export * from "./EditBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c63c7d6",
  null
  
)

export default component.exports